var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":"查看数据","width":"500"},on:{"on-ok":_vm.onOk},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('span',[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }